module.exports = __webpack_public_path__ + "img/3.5a18f13a.jpg";